var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ id: "Calque_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
    React.createElement("circle", { className: styles["st0"] || "st0", cx: "16", cy: "16", r: "15.4" }),
    React.createElement("path", { className: styles["st1"] || "st1", d: "M17.4 16l4.2 4.2c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L16 17.5l-4.2 4.2c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l4.2-4.2-4.2-4.2c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l4.2 4.2 4.2-4.2c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L17.4 16zM4.7 27.4c-6.2-6.2-6.2-16.4 0-22.6 6.2-6.2 16.4-6.2 22.6 0 6.2 6.2 6.2 16.4 0 22.6-6.2 6.2-16.4 6.2-22.6 0zm1.4-1.5c5.5 5.5 14.3 5.5 19.8 0s5.5-14.3 0-19.8S11.6.6 6.1 6.1s-5.5 14.4 0 19.8z" })
  );
});